module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_big.08c60506.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_big.jpg
// module id = 3033
// module chunks = 11